import { RouteName } from '@mews-commander/enums';
import { CommanderThunkAction, WithReservationId } from '@mews-commander/types';
import { ResolveRoute } from '@mews/routing';
import { ReservationTab } from '../types/reservationTab';
import { openModal } from './app/actions/common';

export const getReservationDetailUrl =
    (resolveRoute: ResolveRoute) =>
    ({ reservationId }: { reservationId: string }) =>
        resolveRoute(RouteName.ReservationDetailStatus, { reservationId });

export const RESERVATION_TAB_ROUTE_NAME_MAP: Record<ReservationTab, RouteName> = {
    [ReservationTab.Summary]: RouteName.ReservationDetailSummary,
    [ReservationTab.Status]: RouteName.ReservationDetailStatus,
    [ReservationTab.Properties]: RouteName.ReservationDetailProperties,
    [ReservationTab.Group]: RouteName.ReservationDetailGroup,
    [ReservationTab.Pricing]: RouteName.ReservationDetailPricing,
    [ReservationTab.Items]: RouteName.ReservationDetailItems,
    [ReservationTab.Mailing]: RouteName.ReservationDetailMailing,
    [ReservationTab.ActionLog]: RouteName.ReservationDetailActionLog,
    [ReservationTab.Billing]: RouteName.BillingGroup,
    [ReservationTab.Contracts]: RouteName.ReservationDetailContracts,
};

export const showReservationDetail =
    ({ reservationId, reservationTab }: WithReservationId & { reservationTab: ReservationTab }): CommanderThunkAction =>
    (dispatch, _getState, { resolveRoute }) => {
        const url = resolveRoute(RESERVATION_TAB_ROUTE_NAME_MAP[reservationTab], { reservationId });

        dispatch(openModal(url));
    };
